import Handlebars from 'handlebars';


export function registerHandlebarsHelpers(): void {
  Handlebars.registerHelper('default', function (value: any, defaultValue: any) {
    // Treat undefined, null, and empty string as falsy
    return value !== undefined && value !== null && value !== '' ? value : defaultValue;
  });

  Handlebars.registerHelper('getValue', function (context: any, key: string) {
    return context[key];
  });

  Handlebars.registerHelper('formatDate', function (date: any, locale = 'en-US', options = {}) {
    if (!date) {
      return '';
    }

    const dateObj = new Date(date);
    const formatter = new Intl.DateTimeFormat(locale, options);

    return formatter.format(dateObj);
  });

  Handlebars.registerHelper('ifCond', function (this: any, v1: string, operator: string, v2: string, options: any) {
    switch (operator) {
      case '==':
        return v1 === v2 ? options.fn(this) : options.inverse(this);
      case '===':
        return v1 === v2 ? options.fn(this) : options.inverse(this);
      case '!=':
        return v1 !== v2 ? options.fn(this) : options.inverse(this);
      case '!==':
        return v1 !== v2 ? options.fn(this) : options.inverse(this);
      case '<':
        return v1 < v2 ? options.fn(this) : options.inverse(this);
      case '<=':
        return v1 <= v2 ? options.fn(this) : options.inverse(this);
      case '>':
        return v1 > v2 ? options.fn(this) : options.inverse(this);
      case '>=':
        return v1 >= v2 ? options.fn(this) : options.inverse(this);
      case '&&':
        return v1 && v2 ? options.fn(this) : options.inverse(this);
      case '||':
        return v1 || v2 ? options.fn(this) : options.inverse(this);
      default:
        return options.inverse(this);
    }
  });

  Handlebars.registerHelper('column', function (name: string) {
    return new Handlebars.SafeString(`<div data-column="${name}"></div>`);
  });

  Handlebars.registerHelper('json', (object: any) => JSON.stringify(object));
}
